var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { GeneralTaskTemplate, KtsConstructionMaterialService } from './construction-material.service';
import { ConstructionTask, ConstructionTaskOtherField, DeliveryDestination, KtsConstructionTaskService } from './construction-task.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsGeneralConstructionMaterialComponent = /** @class */ (function (_super) {
    __extends(KtsGeneralConstructionMaterialComponent, _super);
    function KtsGeneralConstructionMaterialComponent(router, route, logger, action, message, page, service, constTaskService, colService, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.constTaskService = constTaskService;
        _this.colService = colService;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.toggles = {};
        // task_m
        _this.taskItems = [];
        // task_u[task_m_id]
        _this.constructionItems = {};
        // task_other_field_u[task_other_field_m_id]
        _this.fieldItems = {};
        // delivery_destination[task_m_id]
        _this.deliveryDestinationItems = {};
        // (material_m + material_u + general_delivery_destination)[task_m_id]
        _this.materials = {};
        _this.deletedMaterials = {};
        _this.seq = 1;
        _this.readonly = false;
        _this.buttonDisp = true;
        return _this;
    }
    KtsGeneralConstructionMaterialComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.taskTemplate = new GeneralTaskTemplate(this.msgSnapshot, this.readonly);
        this.toggles = {};
    };
    KtsGeneralConstructionMaterialComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        var event = this.action.getEvent('materialSave');
        this.buttonDisp = ((typeof event.action === 'undefined') ? false : true);
    };
    KtsGeneralConstructionMaterialComponent.prototype.switchToggle = function (seq) {
        this.toggles[seq] = !this.toggles[seq];
    };
    KtsGeneralConstructionMaterialComponent.prototype.onMsg = function (msg) {
        this.taskTemplate = new GeneralTaskTemplate(msg, this.readonly);
    };
    KtsGeneralConstructionMaterialComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsGeneralConstructionMaterialComponent.prototype.onSubscribe = function (data) {
        // (1)GeneralIndividualConstructionFind(ConstructionMFind)
        if (typeof data.construction_m_id !== 'undefined') {
            this.constructionMId = data.construction_m_id;
            this.constructionItems = {};
            this.fieldItems = {};
            this.deliveryDestinationItems = {};
            for (var _i = 0, _a = this.taskItems; _i < _a.length; _i++) {
                var item = _a[_i];
                this.setTask(item);
                this.setDeliveryDestination(item);
                this.setField(item);
            }
            return;
        }
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            return;
        }
        data = JSOG.parse(JSON.stringify(data));
        // (1)ConstructionMaterialList
        // task_u
        if (typeof data.items[0].task_m_id !== 'undefined' && typeof data.items[0].is_complete !== 'undefined') {
            this.constructionItems = {};
            this.deliveryDestinationItems = {};
            var items = data.items;
            for (var _b = 0, items_1 = items; _b < items_1.length; _b++) {
                var item = items_1[_b];
                item.$type = "put" /* Put */;
                this.constructionItems[item.task_m_id] = item;
                if (item.delivery_destination !== null) {
                    this.deliveryDestinationItems[item.task_m_id] = item.delivery_destination;
                }
            }
            for (var _c = 0, _d = this.taskItems; _c < _d.length; _c++) {
                var item = _d[_c];
                this.setTask(item);
                this.setDeliveryDestination(item);
            }
        }
        // (1)TaskOtherFieldUList
        // task_other_field_u
        if (typeof data.items[0].task_other_field_m_id !== 'undefined') {
            this.fieldItems = {};
            var items = data.items;
            for (var _e = 0, items_2 = items; _e < items_2.length; _e++) {
                var item = items_2[_e];
                item.$type = "put" /* Put */;
                this.fieldItems[item.task_other_field_m_id] = item;
            }
            for (var _f = 0, _g = this.taskItems; _f < _g.length; _f++) {
                var item = _g[_f];
                this.setField(item);
            }
        }
        // (2)TaskMList
        // task_m
        if (typeof data.items[0].project_m_id !== 'undefined' && typeof data.items[0].template_type !== 'undefined') {
            this.taskItems = [];
            var items = data.items;
            this.seq = 1;
            for (var _h = 0, items_3 = items; _h < items_3.length; _h++) {
                var item = items_3[_h];
                if (item.template_type !== "estimate" /* estimate */ && item.template_type !== "order" /* order */ && item.template_type !== "completion" /* completion */) {
                    continue;
                }
                item.$seq = this.seq++;
                if (item.task_other_field_m && item.task_other_field_m.length > 0) {
                    this.constTaskService.sortItems(item.task_other_field_m);
                }
                this.taskItems.push(item);
                this.setTask(item);
                this.setDeliveryDestination(item);
                this.setField(item);
            }
        }
        // (2)GeneralMaterialList
        // material_m + material_u + general_delivery_destination
        if (typeof data.items[0].general_delivery_destination_id !== 'undefined') {
            this.materials = {};
            this.deletedMaterials = {};
            var gmds = data.items;
            var tmids = gmds.map(function (x) { return x.task_m_id; }).filter(function (x, i, self) { return self.indexOf(x) === i; });
            var _loop_1 = function (tmid) {
                this_1.materials[tmid] = gmds.filter(function (x) { return x.task_m_id === tmid; });
            };
            var this_1 = this;
            for (var _j = 0, tmids_1 = tmids; _j < tmids_1.length; _j++) {
                var tmid = tmids_1[_j];
                _loop_1(tmid);
            }
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.setTask = function (item) {
        if (typeof this.constructionItems[item.id] === 'undefined') {
            this.constructionItems[item.id] = Object.assign(new ConstructionTask(), {
                task_m_id: item.id,
                construction_m_id: this.constructionMId
            });
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.setDeliveryDestination = function (item) {
        if (typeof this.deliveryDestinationItems[item.id] === 'undefined') {
            this.deliveryDestinationItems[item.id] = Object.assign(new DeliveryDestination());
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.setField = function (item) {
        for (var _i = 0, _a = item.task_other_field_m; _i < _a.length; _i++) {
            var field = _a[_i];
            if (typeof this.fieldItems[field.id] === 'undefined') {
                this.fieldItems[field.id] = Object.assign(new ConstructionTaskOtherField(), {
                    task_other_field_m_id: field.id,
                    construction_m_id: this.constructionMId
                });
            }
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.onEventSubscribe = function (e) {
        var reg = new RegExp('^' + this.componentName + '#button(\\d+)$');
        var result = e.match(reg);
        if (result !== null) {
            this.setCompRec(parseInt(result[1]));
            // 必須チェック
            var event_1 = this.action.getEvent('materialSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            if (!valid.validation) {
                return;
            }
            // 確認のアラートモーダルを表示
            this.alertModalService.open({
                message: this.msgSnapshot['au.COMPONENT.KtsConstructionMaterialComponent.Modal.save.confirm'],
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#save#ok') {
            // 機器情報保存
            this.action.firstAction('materialSave');
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.onEvent = function (e1, e2, r) {
    };
    KtsGeneralConstructionMaterialComponent.prototype.onChange = function (e, key) {
        if (typeof e.val !== 'undefined') {
            this.constructionItems[key][e.key] = e.val;
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.onChangeDeliveryDestination = function (e, key) {
        if (typeof e.val !== 'undefined') {
            this.deliveryDestinationItems[key][e.key] = e.val;
        }
    };
    KtsGeneralConstructionMaterialComponent.prototype.onChangeField = function (e, key) {
        this.fieldItems[key][e.key] = e.val;
    };
    KtsGeneralConstructionMaterialComponent.prototype.setCompRec = function (id) {
        var constructionData = JSOG.parse(JSON.stringify(this.constructionItems[id]));
        delete constructionData.construction_documents;
        constructionData.delivery_destination = JSOG.parse(JSON.stringify(this.deliveryDestinationItems[id]));
        if (typeof constructionData.delivery_destination !== 'undefined') {
            var delCols = ['cdate', 'cby', 'udate', 'uby', 'base_status'];
            for (var _i = 0, delCols_1 = delCols; _i < delCols_1.length; _i++) {
                var delCol = delCols_1[_i];
                if (typeof constructionData.delivery_destination[delCol] !== 'undefined') {
                    delete constructionData.delivery_destination[delCol];
                }
            }
        }
        var fieldIds = this.taskItems.filter(function (x) { return x.id === id; }).map(function (x) { return x.task_other_field_m; })[0].map(function (x) { return x.id; });
        var fieldData = [];
        var fieldItems = JSOG.parse(JSON.stringify(this.fieldItems));
        for (var _a = 0, fieldIds_1 = fieldIds; _a < fieldIds_1.length; _a++) {
            var fieldId = fieldIds_1[_a];
            var field = fieldItems[fieldId];
            if (!field.value) {
                if (typeof field.id === 'undefined') {
                    continue;
                }
                else {
                    field.$type = "delete" /* Delete */;
                }
            }
            fieldData.push(field);
        }
        for (var _b = 0, _c = this.materials[id]; _b < _c.length; _b++) {
            var material = _c[_b];
            if (typeof material.id === 'undefined' || material.id === null) {
                material.project_m_id = this.getProjectMId(constructionData.task_m_id);
                material.task_u_id = constructionData.id;
                material.type = "special" /* special */;
            }
        }
        this.action.setCompRec(this.componentName, { items: [constructionData] });
        this.action.setCompRec(this.componentName + '#field', { items: fieldData });
        this.action.setCompRec(this.componentName + '#general', { items: this.materials[id] });
        this.action.setCompRec(this.componentName + '#delete', { items: this.deletedMaterials[id] });
    };
    KtsGeneralConstructionMaterialComponent.prototype.getProjectMId = function (taskMId) {
        for (var _i = 0, _a = this.taskItems; _i < _a.length; _i++) {
            var task = _a[_i];
            if (task.id === taskMId) {
                return task.project_m_id;
            }
        }
        return null;
    };
    KtsGeneralConstructionMaterialComponent.prototype.getMaterials = function (id) {
        if (typeof this.materials[id] === 'undefined') {
            this.materials[id] = [];
        }
        return this.materials[id];
    };
    KtsGeneralConstructionMaterialComponent.prototype.getDeletedMaterials = function (id) {
        if (typeof this.deletedMaterials[id] === 'undefined') {
            this.deletedMaterials[id] = [];
        }
        return this.deletedMaterials[id];
    };
    KtsGeneralConstructionMaterialComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-general-construction-material',
                    template: "<form id=\"{{ componentName }}\">\n  <p *ngIf=\"taskItems.length === 0\">{{ (msg | async)['au.COMPONENT.KtsConstructionMaterialComponent.label.noTask'] }}</p>\n  <div *ngFor=\"let taskItem of taskItems; let index = index;\" class=\"row\" [class.-mb-1]=\"index < taskItems.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <p class=\"filter_trigger\">\n          <span [class.open]=\"toggles[taskItem.$seq]\" (click)=\"switchToggle(taskItem.$seq)\">{{ taskItem.name }}</span>\n        </p>\n        <div class=\"-m-1 -mb-2\" [style.display]=\"toggles[taskItem.$seq] ? 'block': 'none'\">\n          <ul class=\"form form-campaign\">\n            <li class=\"stageFlowPane\">\n              <div class=\"stageFlowPane_border\">\n                <div *ngFor=\"let col of taskTemplate.date; let colIndex = index;\" class=\"row -m-1\" [class.-mt-2]=\"colIndex > 0\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"constructionItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, taskItem.id)\"></column>\n                  </div>\n                </div>\n                <div class=\"row -m-1 -mt-2\">\n                  <div class=\"col-sm-12\">\n                    <kts-general-construction-material-list\n                        [componentName]=\"componentName + '#material' + taskItem.$seq\"\n                        [component]=\"{name: componentName + '#material' + taskItem.$seq, params: {primaryKey: 'id', addable: buttonDisp, deletable: buttonDisp}}\"\n                        [generalCols]=\"taskItem.template_type === 'order' ? taskTemplate.materialOrder : taskTemplate.material\"\n                        [materials]=\"getMaterials(taskItem.id)\"\n                        [deletedMaterials]=\"getDeletedMaterials(taskItem.id)\"\n                        (changeMaterial)=\"onChange($event, taskItem.id)\"></kts-general-construction-material-list>\n                  </div>\n                </div>\n                <ng-template [ngIf]=\"taskItem.template_type === 'order'\">\n                  <div *ngFor=\"let col of taskTemplate.deliveryDestination\" class=\"row -m-1 -mt-2\">\n                    <div class=\"col-sm-12\">\n                      <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"deliveryDestinationItems[taskItem.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeDeliveryDestination($event, taskItem.id)\"></column>\n                    </div>\n                  </div>\n                </ng-template>\n                <div *ngFor=\"let field of taskItem.task_other_field_m\" class=\"row -m-1 -mt-2\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName + '#field'\" [index]=\"taskItem.$seq\" [col]=\"{\n                      label: field.name,\n                      key: 'value',\n                      controlType: 'text',\n                      readonly: readonly,\n                      params: {formClass: {width: '100per'}}\n                    }\" [val]=\"fieldItems[field.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeField($event, field.id)\"></column>\n                  </div>\n                </div>\n                <div *ngIf=\"buttonDisp\" class=\"row -m-1 -mt-2\">\n                  <div class=\"col-sm-12\">\n                    <btn [componentName]=\"componentName + '#button' + taskItem.id\"\n                         [component]=\"{\n                            params: {\n                              buttons: [{\n                                type: 'button',\n                                event: componentName + '#button' + taskItem.id,\n                                caption: (msg | async)['Button_save']\n                              }]\n                            }\n                         }\"></btn>\n                  </div>\n                </div>\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsGeneralConstructionMaterialComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsConstructionMaterialService },
        { type: KtsConstructionTaskService },
        { type: ColumnService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    return KtsGeneralConstructionMaterialComponent;
}(ContentBaseComponent));
export { KtsGeneralConstructionMaterialComponent };
//# sourceMappingURL=general-construction-material.component.js.map